import { Navigate, Route } from 'react-router-dom';
import { StaffLayout } from '../../layouts/StaffLayout';
import { Dashboard } from './pages/Dashboard/Dashboard';
import { Deliveries } from './pages/Deliveries/Deliveries';
import { DeliveriesAttention } from './pages/DeliveriesAttention/DeliveriesAttention';
import { Upload } from './pages/Upload/Upload';
import { Account } from '../../pages/Account/Account';
import { Admins } from './pages/Admins/Admins';
import { AdminDetail } from './pages/AdminDetail/AdminDetail';
import { Sellers } from './pages/Sellers';
import { CreateSeller } from './pages/Sellers/CreateSeller';
import { SellerDetail } from './pages/SellerDetail';
import { Partnerships } from './pages/Partnerships/Partnerships';
import { IncomingUpsells } from './pages/IncomingUpsells/IncomingUpsells';
import { Couriers } from './pages/Couriers/Couriers';
import { ExternalIntegrations } from './pages/ExternalIntegrations/ExternalIntegrations';
import { Zones } from './pages/Zones';
import { ZoneDetail } from './pages/ZoneDetail';
import { OrderDetails } from './pages/OrderDetails/OrderDetails';
import { NotFound } from '../../pages/NotFound/NotFound';
import { UPSELLING_HIDDEN } from '../../features/upselling/upsellingConstants';

/**
 * Mounted by `AppRouter` when the session is an admin's **and** carries
 * `is_staff`.
 *
 * Its own tree with its own screens, the way the admin and the seller each have
 * theirs. Several of them started as a copy of the admin's and read the same
 * today; they are here so the internal team's view can grow apart — it looks at
 * every operator at once — without an `isStaff` branch inside a screen that
 * somebody else depends on.
 */
export const staffRoutes = (
  <Route element={<StaffLayout />}>
    <Route path="/home" element={<Navigate to="/dashboard" replace />} />
    <Route path="/dashboard" element={<Dashboard />} />
    <Route path="/deliveries" element={<Deliveries />} />
    <Route path="/deliveries/attention" element={<DeliveriesAttention />} />
    <Route path="/order-details/:orderId" element={<OrderDetails />} />
    <Route path="/upload" element={<Upload />} />
    <Route path="/account" element={<Account />} />
    <Route path="/admins" element={<Admins />} />
    <Route path="/admins/:adminId" element={<AdminDetail />} />
    <Route path="/sellers" element={<Sellers />} />
    <Route path="/sellers/new" element={<CreateSeller />} />
    <Route path="/sellers/:companyId" element={<SellerDetail />} />
    {/* Upselling is hidden for now: its addresses go with its menu entries, or
        they stay reachable by typing them. See `UPSELLING_HIDDEN`. */}
    {!UPSELLING_HIDDEN && <Route path="/partnerships" element={<Partnerships />} />}
    {!UPSELLING_HIDDEN && <Route path="/incoming-upsells" element={<IncomingUpsells />} />}
    <Route path="/my-providers-credentials" element={<Couriers />} />
    <Route path="/external-integrations" element={<ExternalIntegrations />} />
    <Route path="/shipping-zones" element={<Zones />} />
    <Route path="/shipping-zones/:zoneId" element={<ZoneDetail />} />
    {/* No pickups: arranging a courier's collection is the operator's own
        errand, and the internal team does not stand in for it. */}
    {/* Inside the layout on purpose: a wrong address is not a reason to
        take the sidebar away from someone who is signed in. */}
    <Route path="*" element={<NotFound />} />
  </Route>
);
